import { render, staticRenderFns } from "./FamilyHistoryForm.vue?vue&type=template&id=be181360&scoped=true&"
import script from "./FamilyHistoryForm.vue?vue&type=script&lang=js&"
export * from "./FamilyHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./FamilyHistoryForm.vue?vue&type=style&index=0&id=be181360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be181360",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
